module.exports = __webpack_public_path__ + "img/follow_bg_desc.60fad26d.webp";